import React, { useEffect, useState } from 'react';
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import axios from 'axios';

const Inbox = () => {
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        fetchEmails();
    }, []);

    const fetchEmails = async () => {
        try {
            const response = await axios.get('https://form.cpccbe.org/api/emails/');
            setEmails(response.data);
        } catch (error) {
            console.error("Error fetching emails:", error);
        }
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Inbox
            </Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Sender</TableCell>
                            <TableCell>Recipient</TableCell>
                            <TableCell>Subject</TableCell>
                            <TableCell>Body</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {emails.map((email) => (
                            <TableRow key={email._id}>
                                <TableCell>{email.sender}</TableCell>
                                <TableCell>{email.recipient}</TableCell>
                                <TableCell>{email.subject}</TableCell>
                                <TableCell>{email.body}</TableCell>
                                <TableCell>{new Date(email.createdAt).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default Inbox;
